<template lang="pug">
.send-request-histories-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    //- ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    //- レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    //- フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    //- セル：状態
    template(#cell(ended)="row")
      StatusSwitch(v-model="row.item.ended" @onSwitch="onSwitch(row.item)")
    //- セル：送信日時
    template(#cell(datetime)="row")
      span {{ convertSendDatetime(row.item) }}
    //- セル：利用者（患者）名
    template(#cell(residentName)="row")
      span {{ row.item.residentName }}
    //- セル：送信内容
    template(#cell(requestDetail)="row")
      button.btn.detail-btn(@click="onRequestDetail(row.item)") 詳細
    //- セル：入所可否確認
    template(#cell(replyAcceptance)="row")
      span(v-if="row.item.replyAcceptance" style="color:rgba(0, 140, 160, 1); font-weight:bold;") する
      span(v-else) しない
    //- セル：返信状況
    template(#cell(replyDetail)="row")
      .d-flex.flex-align-center.flex-row
        .count-area.d-flex.align-items-center.justify-content-end
          span.mr-2 {{ getRepliedFacilityCount(row.item) }}/{{ getSendFacilityCount(row.item) }}件
        .button-area.d-flex.align-items-center.justify-content-end
          button.btn.confirm-btn.mr-2(@click="onRepliesDetail(row.item)") 詳細
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { OtherOfficeAcceptanceRequestsGetModel } from "@/commons/services/OtherOfficeAcceptanceRequests";

import StatusSwitch from "@/pc/basics/StatusSwitch.vue";

@Component({
  components: {
    StatusSwitch
  }
})
export default class SendRequestHistoriesTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<SendRequestHistoriesTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<SendRequestHistoriesTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<SendRequestHistoriesTableItem> {
    return this.value;
  }

  /**
   * ### フィルタリング
   */
  filterTable(row: SendRequestHistoriesTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(row, filter);
  }

  private filterSearchWords(row: SendRequestHistoriesTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundResidentName: boolean = true;

    for (const word of words) {
      // 宛先
      if (row.residentName.indexOf(word) == -1) {
        foundResidentName = false;
      }
    }

    return foundResidentName;
  }

  /**
   * ### フィルタリングイベント
   */
  onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 画面表示用の日付を返す
   */
  convertSendDatetime(item: SendRequestHistoriesTableItem): string {
    if (item.datetime) {
      return this.$dateUtil.convertNumberToString(Number(item.datetime), "yyyy/mm/dd hh:MM");
    } else {
      return "";
    }
  }

  getRepliedFacilityCount(item: SendRequestHistoriesTableItem): number {
    if (item.repliedFacilityIds) {
      return item.repliedFacilityIds.length;
    } else {
      return 0;
    }
  }

  getSendFacilityCount(item: SendRequestHistoriesTableItem): number {
    if (item.sendFacilityIds) {
      return item.sendFacilityIds.length;
    } else {
      return 0;
    }
  }

  /**
   * ### 状態変更イベント
   */
  onSwitch(item: SendRequestHistoriesTableItem): void {
    this.$emit("onChangeEnded", item);
    return;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  onRequestDetail(item: SendRequestHistoriesTableItem): void {
    this.$emit("onRequestDetail", item);
    return;
  }

  /**
   * ### 確認ボタン押下イベント
   */
  onRepliesDetail(item: SendRequestHistoriesTableItem): void {
    this.$emit("onRepliesDetail", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface SendRequestHistoriesTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface SendRequestHistoriesTableItem extends OtherOfficeAcceptanceRequestsGetModel {}

export interface FilterSetting {
  /** 検索ワード */
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.send-message-history-table-component {
  .detail-btn {
    width: 64px;
  }
}
</style>
